//import {test_function} from "./../functions/test_function.js";



import { getId } from "../../universal_methods/getId.js";
import { setId } from "../../universal_methods/setId.js";
import { generateId } from "../../universal_methods/generateId.js";
import { isEmpty } from "../../universal_methods/isEmpty.js";
import { getAttributes } from "../../universal_methods/getAttributes.js";
import { toggleDisplay } from "../../universal_methods/toggleDisplay.js";

import { setTxt } from "../../universal_methods/setTxt.js";
import { SmetioPhotoAndDescription } from "../../smetioPhotoAndDescription/v1.0.0/smetioPhotoAndDescription.js";
import { REVIVE_CHECKBOX_SEPERATOR } from "@schaniag/private";

export class SmetioPhotoCheckbox {

    constructor(data = {
        attributes: {},
        changeEvents: {
            onChecked: (value) => { },
            onUnChecked: (value) => { },
        }
    }) {

        // super(data);


        this.getId = getId;
        this.setId = setId;
        this.generateId = generateId;
        this.isEmpty = isEmpty;
        this.getAttributes = getAttributes;
        this.toggleDisplay = toggleDisplay;
        this.setTxt = setTxt;


        // this.isReadonly = data.attributes.isReadonly || false;
        // this.inputIsChecked = data.attributes.checked === true ? true : false;
        // this.changeEvents = data.changeEvents;
        this.isReadonly = data.attributes ? data.attributes.isReadonly : false;
        this.viewStyle = data.attributes ? data.attributes.viewStyle || "listView" : "listView"; // "listView" OR cardView
        this.photoAndDescriptionSettings = data.photoAndDescriptionSettings || {};
        /* 
        orientation:"vertical", 
        boxWidth:"45%", 
        boxMargin:"2.5px", 
        boxPadding:"2.5px", 
        photoWidth:"50px",
        photoVPosition: "center",
        descriptionVPosition: "center",
    */


        this.onChecked = data.events ? data.events.onChecked : null;
        this.onUnChecked = data.events ? data.events.onUnChecked : null;
        this.onChange = data.events ? data.events.onChange : null;
        this.onFocus = data.events ? data.events.onFocus : null;
        this.onFocusOut = data.events ? data.events.onFocusOut : null;



        this.validation = data.validation || {};
        this.options = data.options;
        this.optionsClasses = {};
        this.valueObject = {};
        this.value = data.attributes ? data.attributes.value : "";
        this.minLength = this.validation.minLength || 2;
        this.maxLength = this.validation.maxLength || 3;
        this.showSearchBar = data.showSearchBar === false ? false : true;
        this.label = data.label;
        this.headingSize = data.headingSize || "h6";
        this.headingBottomMargin = data.headingBottomMargin || 20;
        this.instruction = data.instruction;
        this.isReadonly = data.attributes ? data.attributes.isReadonly: false;
        this.isHidden = data.isHidden;
        this.hidePhoto = data.attributes.hidePhoto;


        this.setId();
        // this.getId();

        this.photoCheckboxClass = "smetio-photo-checkbox-" + this.id;
        this.photoCheckboxAttributes = {
            "data-smetio-read-only": this.isReadonly,
            "data-smetio-is-visible": this.isHidden === true ? false : true,
            class: ["smetio-photo-checkbox", this.photoCheckboxClass]
        };

        // optionsDiv
        this.optionsDivClass = "smetio-photo-checkbox-options-" + this.id;
        this.optionsDivAttributes = {
            class: ["smetio-photo-checkbox-options", this.optionsDivClass]
        };

        // searchAndSelectAll 
        this.searchAndSelectAllClass = "smetio-photo-checkbox-search-and-select-all-" + this.id;
        this.searchAndSelectAllAttributes = {
            class: ["smetio-photo-checkbox-search-and-select-all", this.searchAndSelectAllClass]
        };

        // searchDiv
        this.searchDivClass = "smetio-photo-checkbox-search-" + this.id;
        this.searchDivAttributes = {
            class: ["smetio-photo-checkbox-search", this.searchDivClass]
        };

        // searchInput
        this.searchInputClass = "smetio-photo-checkbox-search-input-" + this.id;
        this.searchInputAttributes = {
            type: "text",
            placeholder: "Search",
            class: ["smetio-photo-checkbox-search-input", this.searchInputClass]
        };

        // selectAndDeselectDiv 
        this.selectAndDeselectDivClass = "smetio-photo-checkbox-select-and-deselect-" + this.id;
        this.selectAndDeselectDivAttributes = {
            class: ["smetio-photo-checkbox-select-and-deselect", this.selectAndDeselectDivClass]
        };

        // selectAll
        this.selectAllClass = "smetio-photo-checkbox-select-all-" + this.id;
        this.selectAllAttributes = {
            class: ["smetio-photo-checkbox-select-and-deselect-btn", "smetio-photo-checkbox-select-all", this.selectAllClass]
        };

        // deSelectAll
        this.deSelectAllClass = "smetio-photo-checkbox-de-select-all-" + this.id;
        this.deSelectAllAttributes = {
            class: ["smetio-photo-checkbox-select-and-deselect-btn", "smetio-photo-checkbox-de-select-all", this.deSelectAllClass]
        };

        // errorText
        this.errorTextClass = "smetio-photo-checkbox-error-text-" + this.id;
        this.errorTextAttributes = {
            class: ["smetio-danger-text", "smetio-p-text", "smetio-margin-bottom-15", "smetio-photo-checkbox-error-text", this.errorTextClass]
        };







    };
    changeReadonlyStatus({ newStatus = true }) {

        this.isReadonly = newStatus;

        $("." + this.photoCheckboxClass).attr("data-smetio-read-only", this.isReadonly);

    };

    getValue() {
        return this.value;
    };

    async extractValue(validate) {

        const replaceLastOccuranceInString = (await import(/* webpackPrefetch: true */ "../../../functions/replace/replaceLastOccuranceInString.js")).replaceLastOccuranceInString;

        this.value = "";

        for (const key in this.valueObject) {
            this.value += this.valueObject[key] + REVIVE_CHECKBOX_SEPERATOR;
        };

        this.value = replaceLastOccuranceInString(REVIVE_CHECKBOX_SEPERATOR, "", this.value);

        if(validate !== false) this.isValid();
        return this.value;

    };

    scrollToTop() {

        // $(`.${this.photoCheckboxClass}`).parent().animate({ scrollTop: 0 }, "fast");
        $(`.${this.photoCheckboxClass}`).parents().animate({ scrollTop: 0 }, "fast");
        $(`.${this.errorTextClass}`).parents().animate({ scrollTop: 0 }, "fast");
    };

    showError(error) {

        if(this.isEmpty(error)) return false;

        console.log("I am showing error ", error);

        const errorText = this.setTxt({
            attributes: this.selectAllAttributes,
            txt: error,
            type: "html"
        });

        $("." + this.errorTextClass).html(errorText).show();

        this.scrollToTop();

        return false;

    };

    hideError() {
        $("." + this.errorTextClass).hide();
        return true;
    };

    isValid() {

        if (Object.keys(this.valueObject).length > this.maxLength) return this.showError("txt1120");
        if (Object.keys(this.valueObject).length < this.minLength) return this.showError("txt1121");

        return this.hideError();
    };

    async select(id) {

        if(this.optionsClasses[id]["attributes"]["selected"] === true) return true;

        const { smetioPhotoAndDescription, attributes } = this.optionsClasses[id];

        smetioPhotoAndDescription.select(id);

        this.optionsClasses[id]["attributes"]["selected"] = true;
    
        this.valueObject[id] = this.optionsClasses[id]["attributes"]["value"];
        if (this.onChecked) this.onChecked({ id, valueObject: this.valueObject, value:this.value });

        if(this.isSmetioPhotoRadioInput === true) this.deSelectAll({validate:false, exclude:id});

        const validate = this.isSmetioPhotoRadioInput === true ? false : true;

        return this.extractValue(validate);

    };

    deSelect(id, validate) {

        if(this.optionsClasses[id]["attributes"]["selected"] === false) return true;

        const { smetioPhotoAndDescription, attributes } = this.optionsClasses[id];

        smetioPhotoAndDescription.deselect(id);
        if (id in this.valueObject) delete this.valueObject[id]; 
        this.optionsClasses[id]["attributes"]["selected"] = false;

        if (this.onUnChecked) this.onUnChecked({ id, valueObject: this.valueObject, value:this.value });

        return this.extractValue(validate);

    };

    selectAll() {
        for (const key in this.optionsClasses) {
            if(this.optionsClasses[key]["attributes"]["selected"] === true) continue;
            this.select(key);
        };

    };

    deSelectAll(data={}) {

        const {validate, exclude} = data;

        for (const key in this.optionsClasses) {

            if(key == exclude) continue;

            if(this.optionsClasses[key]["attributes"]["selected"] === false) continue;

            this.deSelect(key, validate);
        };

    };


    toggleSelect(id) {

        if (!this.optionsClasses[id]) return false;

        const { smetioPhotoAndDescription, attributes } = this.optionsClasses[id];

        const selectToggled = attributes.selected === true ? this.deSelect(id) : this.select(id);

    };

    getSettingsForPhotoAndDescription() {

        if (this.photoAndDescriptionSettings) return this.photoAndDescriptionSettings;

        return {
            orientation: "horizontal",
            boxWidth: this.viewStyle == "listView" ? "100%" : "45%",
            boxPadding: this.viewStyle == "listView" ? "10px" : "5px",
            boxMargin: this.viewStyle == "listView" ? "10px" : "5px",
            descriptionVPosition: this.viewStyle == "listView" ? "center" : "top",
            photoWidth: this.viewStyle == "listView" ? "100px" : "50px",
            photoVPosition: this.viewStyle == "listView" ? "center" : "top",
        };

        // orientation:"vertical", 
        // boxWidth:"45%", 
        // boxMargin:"2.5px", 
        // boxPadding:"2.5px", 
        // photoWidth:"50px",
        // photoVPosition: "center",
        // descriptionVPosition: "center",

    };

    getOptions() {

        /*     this.options = [
      {
        text: "Nigeria",
        photo: "http://localhost:3000/img/home_page_front_photo_1.jpeg", // FOR PHOTO CHECKBOX AND PHOTO RADIO
        attributes: {
          value: "ng",
          selected: true // OR FALSE   
        }
      },
      {
        text: "Norway",
        photo: "http://localhost:3000/img/home_page_front_photo_2.jpeg", // FOR PHOTO CHECKBOX AND PHOTO RADIO
        attributes: {
          value: "no",
          selected: false // OR FALSE   
        }
      },

      {
        text: "Finland",
        photo: "http://localhost:3000/img/home_page_front_photo_3.jpeg", // FOR PHOTO CHECKBOX AND PHOTO RADIO
        attributes: {
          value: "fi",
          selected: true // OR FALSE   
        }
      },

      {
        text: "Poland",
        photo: "http://localhost:3000/img/home_page_front_photo_4.jpeg", // FOR PHOTO CHECKBOX AND PHOTO RADIO
        attributes: {
          value: "pl",
          selected: false // OR FALSE   
        }
      },
      {
        text: "Nigeria",
        photo: "http://localhost:3000/img/home_page_front_photo_1.jpeg", // FOR PHOTO CHECKBOX AND PHOTO RADIO
        attributes: {
          value: "ng",
          selected: true // OR FALSE   
        }
      },
      {
        text: "Norway",
        photo: "http://localhost:3000/img/home_page_front_photo_2.jpeg", // FOR PHOTO CHECKBOX AND PHOTO RADIO
        attributes: {
          value: "no",
          selected: false // OR FALSE   
        }
      },

      {
        text: "Finland",
        photo: "http://localhost:3000/img/home_page_front_photo_3.jpeg", // FOR PHOTO CHECKBOX AND PHOTO RADIO
        attributes: {
          value: "fi",
          selected: true // OR FALSE   
        }
      },

      {
        text: "Poland",
        photo: "http://localhost:3000/img/home_page_front_photo_4.jpeg", // FOR PHOTO CHECKBOX AND PHOTO RADIO
        attributes: {
          value: "pl",
          selected: false // OR FALSE   
        }
      },
    ];
 */
        let output = "";

        const settings = this.getSettingsForPhotoAndDescription();


        for (let i = 0; i < this.options.length; i++) {
            const option = this.options[i];
            const smetioPhotoAndDescription = new SmetioPhotoAndDescription({
                icon:option.icon,
                photo: option.photo,
                description: option.text,
                isSelected: option.attributes.selected,
                hidePhoto: this.hidePhoto,
                ...settings,
                onClicked: (data = {}) => {
                    const { id } = data;
                    if( this.isSmetioPhotoRadioInput !== true) return this.toggleSelect(id);
                    return this.select(id);
                }
            });

            const id = smetioPhotoAndDescription.getId();
      

            this.optionsClasses[id] = {};
            this.optionsClasses[id].smetioPhotoAndDescription = smetioPhotoAndDescription;
            this.optionsClasses[id].attributes = option.attributes;
            this.optionsClasses[id].attributes.text = option.text;
            if(option.attributes.selected == true) this.valueObject[id] = option.attributes.value;

      
            // output += smetioPhotoAndDescription.render();
            const output = smetioPhotoAndDescription.render();
            $(`.${this.optionsDivClass}`).append(output);

            const validate = false;
            this.extractValue(validate);

        };

    };

    getSelectAndDeselectBtn(){

        const selectAllText = this.setTxt({
            attributes: this.selectAllAttributes,
            txt: "txt265",
            type: "title"
        });

        const deselectAllText = this.setTxt({
            attributes: this.deSelectAllAttributes,
            txt: "txt263",
            type: "title"
        });

        return `
      <div ${this.getAttributes(this.selectAndDeselectDivAttributes, false)} >

        <div ${this.getAttributes(this.selectAllAttributes, false)}>
          <i class="smetio-icon smetio-icon-checkbox-checked"> </i>
        </div>

        <div ${this.getAttributes(this.deSelectAllAttributes, false)} >
          <i class="smetio-icon smetio-icon-checkbox-unchecked"> </i>
        </div>

      </div>
    `;

    };

    getSearchBar() {


        const searchText = this.setTxt({
            attributes: this.searchInputAttributes,
            txt: "txt201",
            type: "placeholder"
        });

        const selectAndDeselectBnt = this.isSmetioPhotoRadioInput !== true ? this.getSelectAndDeselectBtn() : "";


        return `
      <div ${this.getAttributes(this.searchAndSelectAllAttributes, false)}>

        <div ${this.getAttributes(this.searchDivAttributes, false)} >
          <input ${this.getAttributes(this.searchInputAttributes, false)}  />
        </div>

        ${selectAndDeselectBnt}

      </div>
    `;

    };

    render() {

        setTimeout(() => {
            this.getOptions();
        }, 300);

        const searchBar = this.showSearchBar === true ? this.getSearchBar() : "";

        this.events();

        const label = this.setTxt({
            attributes: {},
            txt: this.label,
            type: "html"
        });
    
        const instructionText = this.setTxt({ attributes: {}, txt: this.instruction, type: "html" });
        const instruction = this.instruction ? `<p class=" smetio-photo-checkbox-instruction smetio-p-text smetio-margin-bottom-20" > ${instructionText} </p>` : "";

        return `
            <div ${this.getAttributes(this.photoCheckboxAttributes, false)} > 

                <${this.headingSize} class="smetio-${this.headingSize}-heading smetio-margin-bottom-${this.headingBottomMargin}"> ${label} </${this.headingSize}>    
                
                ${instruction}

                ${searchBar}

                <p ${this.getAttributes(this.errorTextAttributes, false)}> </p>

                <div ${this.getAttributes(this.optionsDivAttributes, false)} >
                
                </div>

            </div>
        `;

    };

    hideAll() {

        for (const key in this.optionsClasses) {
            const { smetioPhotoAndDescription } = this.optionsClasses[key];
            smetioPhotoAndDescription.hide();
        };

    };

    showAll() {

        for (const key in this.optionsClasses) {
            const { smetioPhotoAndDescription } = this.optionsClasses[key];
            smetioPhotoAndDescription.show();
        };

    };

    search(searchWord) {

        searchWord = searchWord.toLowerCase();

        if (this.isEmpty(searchWord)) return this.showAll();

        this.hideAll();

        for (const key in this.optionsClasses) {
            const { smetioPhotoAndDescription, attributes } = this.optionsClasses[key];
            const { text, value } = attributes;

            if (value.toLowerCase().indexOf(searchWord) > -1 || text.toLowerCase().indexOf(searchWord) > -1) smetioPhotoAndDescription.show();

        };

    };

    async events() {

        const debounce = (await import(/* webpackPrefetch: true */ "throttle-debounce")).debounce;

        $("body").on("mousedown", "." + this.selectAllClass, () => {

            this.selectAll();

        });

        $("body").on("mousedown", "." + this.deSelectAllClass, () => {

            this.deSelectAll();

        });

        $("body").on("keyup search change", "." + this.searchInputClass, debounce(500, () => {

            let searchWord = $("." + this.searchInputClass).val();

            this.search(searchWord);

        }));

    };


};
